import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Paper from "@material-ui/core/Paper"

import PubsList from "./PubsList"
import Typography from "../LandingComponents/Typography"

import pubs2026 from "../../../content/publications/2026Publications.yml"
import pubs2025 from "../../../content/publications/2025Publications.yml"
import pubs2024 from "../../../content/publications/2024Publications.yml"
import pubs2023 from "../../../content/publications/2023Publications.yml"
import pubs2022 from "../../../content/publications/2022Publications.yml"
import pubs2021 from "../../../content/publications/2021Publications.yml"
import pubs2020 from "../../../content/publications/2020Publications.yml"
import pubs2019 from "../../../content/publications/2019Publications.yml"
import pubs2018 from "../../../content/publications/2018Publications.yml"
import pubs2017 from "../../../content/publications/2017Publications.yml"
import pubs2016 from "../../../content/publications/2016Publications.yml"
import pubs2015 from "../../../content/publications/2015Publications.yml"
import pubs2014 from "../../../content/publications/2014Publications.yml"
import pubs2013 from "../../../content/publications/2013Publications.yml"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: theme.palette.primary.light,
    overflow: "hidden",
  },
  container: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(15),
  },
  paper: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}))

export default function Dashboard() {
  const classes = useStyles()

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography variant="h4" marked="center" align="center" component="h2">
          Publications
        </Typography>

        <Paper className={classes.paper}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Selected Publications
          </Typography>

          <PubsList year={2026} rows={pubs2026} />
          <PubsList year={2025} rows={pubs2025} />
          <PubsList year={2024} rows={pubs2024} />
          <PubsList year={2023} rows={pubs2023} />
          <PubsList year={2022} rows={pubs2022} />
          <PubsList year={2021} rows={pubs2021} />
          <PubsList year={2020} rows={pubs2020} />
          <PubsList year={2019} rows={pubs2019} />
          <PubsList year={2018} rows={pubs2018} />
          <PubsList year={2017} rows={pubs2017} />
          <PubsList year={2016} rows={pubs2016} />
          <PubsList year={2015} rows={pubs2015} />
          <PubsList year={2014} rows={pubs2014} />
          <PubsList year={2013} rows={pubs2013} />
        </Paper>
      </Container>
    </section>
  )
}
